export default __webpack_public_path__ + "static/media/32.a178a91a.png";